import { Component, Inject, DestroyRef, inject } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { UnespCoreMessageService } from 'src/libs/unesp-core'
import { GestaoUsuarioService } from 'src/app/services/gestao-usuario.service'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

export interface DialogBuscarUsuarioData {
  codigoUnidadePrefix: string
  currentUsername: string
  isSuperAdmin?: boolean
}

@Component({
  selector: 'app-dialog-buscar-usuario',
  templateUrl: './dialog-buscar-usuario.component.html',
  styleUrls: ['./dialog-buscar-usuario.component.scss'],
})
export class DialogBuscarUsuarioComponent {
  private destroyRef = inject(DestroyRef)

  usernameFC = new FormControl('', Validators.required)
  usuario: any = null
  buscando = false
  cadastrando = false
  limiteAtingido = false

  constructor(
    private gestaoUsuarioService: GestaoUsuarioService,
    private unespCoreMessageService: UnespCoreMessageService,
    public dialogRef: MatDialogRef<DialogBuscarUsuarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogBuscarUsuarioData
  ) {}

  buscar() {
    if (!this.usernameFC.valid) return
    this.buscando = true
    this.usuario = null
    this.limiteAtingido = false
    this.gestaoUsuarioService.buscarUsuario(this.usernameFC.value!).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: result => {
        this.usuario = result
        this.buscando = false
        this.verificarLimite()
      },
      error: () => {
        this.buscando = false
        this.unespCoreMessageService.showMessageError('Usuário não encontrado')
      }
    })
  }

  private verificarLimite() {
    const codigoCompleto = this.usuario?.codigoUnidade || ''
    let prefix = codigoCompleto.split('.')[0]
    if (prefix.length === 1) prefix = '0' + prefix
    if (prefix) {
      this.gestaoUsuarioService.contarAdmins(prefix).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(count => {
        this.limiteAtingido = count >= 5
      })
    }
  }

  podeCadastrar(): boolean {
    if (!this.usuario) return false
    if (this.usuario.email === this.data.currentUsername) return false
    if (this.usuario.isDocente) return false
    if (this.usuario.jaCadastrado) return false
    if (this.limiteAtingido) return false
    return true
  }

  getMotivoBloqueioCadastro(): string {
    if (!this.usuario) return ''
    if (this.usuario.email === this.data.currentUsername) return 'Você não pode cadastrar a si mesmo.'
    if (this.usuario.isDocente) return 'Docentes não podem ser cadastrados como administradores de concursos.'
    if (this.usuario.jaCadastrado) return 'Este usuário já está cadastrado no sistema.'
    if (this.limiteAtingido) {
      const max = this.data.isSuperAdmin ? '5' : '4 indicados'
      return `Limite de administradores por unidade atingido (máximo ${max}). Para cadastrar mais, abra um chamado com a justificativa necessária.`
    }
    return ''
  }

  cadastrar() {
    if (!this.podeCadastrar()) return
    this.cadastrando = true
    const { username, email, codigoUnidade, matricula, nome } = this.usuario
    this.gestaoUsuarioService.criar(username, email, codigoUnidade || '', matricula || '', nome, 'CONCURSOADMIN').pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.unespCoreMessageService.showMessageSuccess(`Usuário ${nome} cadastrado como Administrador de Concursos`)
        this.dialogRef.close(true)
      },
      error: (err: any) => {
        this.cadastrando = false
        if (err?.status === 409) {
          this.limiteAtingido = true
          this.unespCoreMessageService.showMessageError(err.error?.message || 'Limite de administradores atingido.')
        }
      }
    })
  }
}
